export type { ApitallyConfig, ApitallyConsumer } from "../common/types.js";
export { apitallyPlugin, setConsumer } from "./plugin.js";
